import React, { useState } from 'react';
import './MuultiStyle.css';

export default function GateBadge({ gateNamesLabel, onResetPasswordAccess, resetPasswordError }) {
    const [resetError, setResetError] = useState('');
    const resetPasswordAccess = (event) => {
        event.preventDefault();
        event.stopPropagation();
        try {
            const cleared = onResetPasswordAccess();
            setResetError(cleared ? '' : 'Could not clear the saved unlock. Please try again.');
        } catch {
            setResetError('Could not clear the saved unlock. Please try again.');
        }
    };
    const normalized = String(gateNamesLabel || '').trim();
    if (!normalized) return null;
    const isPublic = normalized.toLowerCase() === 'public';
    const badgeLabel = normalized.toLowerCase() === 'password' ? 'password' : normalized;

    return (
        <div className="gate-badge" role="status" style={{ color: 'inherit' }}>
            <small>{isPublic ? 'Public — no gate required' : 'Unlocked with ' + badgeLabel}</small>
            {onResetPasswordAccess && (
                <button
                    type="button"
                    aria-label="Reset saved password unlock for this panel"
                    title="Forget this panel's saved password unlock"
                    onClick={resetPasswordAccess}
                    style={{
                        marginLeft: 6, padding: '0 5px', minWidth: 20, lineHeight: '18px',
                        border: '1px solid currentColor', borderRadius: 4,
                        background: 'transparent', color: 'inherit', cursor: 'pointer',
                    }}
                >
                    {'\u2212'}
                </button>
            )}
            {(resetPasswordError || resetError) && (
                <small role="alert" style={{ display: 'block' }}>{resetPasswordError || resetError}</small>
            )}
        </div>
    );
}
